import { useState } from 'react';
import { useUpsertLinesService } from '../services/upsertLinesService';
import { Line } from '../types';

export const useUpsertLines = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { upsertLines: upsertLinesService } = useUpsertLinesService();

  const upsertLines = async (returnHeaderId: string, lines: Line[], status?: string) => {
    setLoading(true);
    setError(null);

    try {
      const result = await upsertLinesService({
        returnHeaderId,
        lines,
        status
      });

      return result;
    } catch (err: any) {
      const errorMessage = err.message || 'Failed to save lines';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    upsertLines,
    loading,
    error
  };
};